let ac = null;
const ctx = () => {
  if (!ac) ac = new (window.AudioContext || window.webkitAudioContext)();
  if (ac.state === "suspended") ac.resume();
  return ac;
};

export function tone(freq, dur = 0.18, delay = 0, type = "sine", gain = 0.18) {
  const c = ctx();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.value = 0;
  o.connect(g).connect(c.destination);
  const t = c.currentTime + delay;
  g.gain.linearRampToValueAtTime(gain, t + 0.02);
  g.gain.linearRampToValueAtTime(0, t + dur);
  o.start(t);
  o.stop(t + dur + 0.05);
}

export function beep() { tone(880, 0.12); }

// Soft two-tone alarm loop. Returns a stop() function.
export function startAlarm(url) {
  if (url) {
    const a = new Audio(url);
    a.loop = true;
    a.volume = 0.6;
    a.play().catch(() => {});
    return () => { a.pause(); a.currentTime = 0; };
  }
  const ring = () => { tone(620, 0.35, 0, "sine", 0.12); tone(480, 0.35, 0.4, "sine", 0.12); };
  ring();
  const id = setInterval(ring, 1100);
  return () => clearInterval(id);
}

export function playCelebration(url) {
  if (url) { const a = new Audio(url); a.volume = 0.7; a.play().catch(() => {}); return; }
  const notes = [523, 659, 784, 1047, 784, 1047];
  notes.forEach((n, i) => tone(n, 0.22, i * 0.17, "triangle", 0.16));
}

export function playCountTick(n) { tone(n <= 1 ? 1047 : 660, 0.16, 0, "square", 0.12); }
